import React, { useEffect, useRef, useState } from "react";
import "./Topbar.css";
import Api from "../Services/Api";
import { useAuth } from "../auth/AuthContext";
import { canAccessAdminArea, normalizeAccessType } from "../../utils/accessControl";

const getInitials = (name = "") => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "U";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Topbar = ({ page, onToggleMenu }) => {
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const menuRef = useRef(null);

  const { user } = useAuth(); // ✅ fonte correta

  const accessType = normalizeAccessType(user?.access_type);
  const isAdmin = canAccessAdminArea(accessType);
  const avatarClass = isAdmin ? "avatar-admin" : "avatar-licensed";

  const userName = user?.full_name || "Usuário";
  const initials = getInitials(userName);

  const handleLogout = async () => {
    try {
      await Api.post("/auth/logout"); // se sua rota for outra, ajusta aqui
    } catch (e) {}

    localStorage.removeItem("token"); // se você usa
    window.location.href = "/";
  };

  useEffect(() => {
    const onClickOutside = (e) => {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target)) setOpenUserMenu(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button className="menu-toggle-btn" onClick={onToggleMenu} type="button">
          <span>☰</span>
          <span>Menu</span>
        </button>
        <div className="page-title">{page}</div>
      </div>

      <div className="topbar-right" ref={menuRef}>
        <button
          type="button"
          className="user-chip"
          onClick={() => setOpenUserMenu((v) => !v)}
          aria-haspopup="menu"
          aria-expanded={openUserMenu}
          title={userName}
        >
          <span className={`user-avatar ${avatarClass}`}>{initials}</span>
        </button>

        {openUserMenu && (
          <div className="user-dropdown" role="menu">
            <div className="user-dropdown-header">
              <div className={`user-avatar big ${avatarClass}`}>{initials}</div>
              <div className="user-meta">
                <div className="user-name">{userName}</div>
                {user?.email ? <div className="user-email">{user.email}</div> : null}
              </div>
            </div>

            <button className="logout-btn" type="button" onClick={handleLogout}>
              Sair
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Topbar;
